import React, { useState, useEffect, useContext } from "react"
import { Context } from "../../utils/context"
import { isFormValid, onGetFormData, onInitForm, onSetErrorsToForm } from "../../utils/utility"
import usaFlag from "../../assets/flags/united-states.png"
import mexicoFlag from "../../assets/flags/mexico.png"

const AMOUNT = 5

const useBalanceModal = ({open, cardholder, onClose}) => {

    const { axios, authData, setAuthData, resetAuth } = useContext(Context)
    const authToken = `Bearer ${authData.token}`

    const [loading, setLoading] = useState(false)
    const [sending, setSending] = useState(false)
    const [error, setError] = useState(null)
    //const [cardholder, setCardholder] = useState()
    const [step, setStep] = useState(1)
    const [balance, setBalance] = useState(null)
    const [mode, setMode] = useState(1)
    const [originalBalance, setOriginalBalance] = useState(0)

    const [success, setSucces] = useState(false)

    const isNumeric = (str) => {
        if (typeof str != "string") return false // we only process strings!  
        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
               !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
      }

    //const [form, setForm] = useState(JSON.parse(JSON.stringify(form_data)))

    useEffect(() => {
        if(open && cardholder){
            actions.onInitModule()
        }else{
            setError(null)
            setBalance(null)
            //setForm(JSON.parse(JSON.stringify(form_data)))
            setLoading(false)
            setStep(1)
        }
    }, [open, cardholder])

    useEffect(()=>{window.scrollTo(0,0)}, [])
    
    const actions = {
        onInitModule: async() => {
            setLoading(true)
            try {
                console.log(cardholder)
                const cardID = cardholder?.idCard
                console.log('Card ID -> ', cardID)
                axios.defaults.headers.common['Authorization'] = authToken
                const response = await axios.get(`/balance/${cardID}/closed`)
                const _balance = response.data.data.balance
                console.log(_balance)
                //setBalance(_balance)
                setOriginalBalance(_balance)
                //setForm(_form)
            } catch (error) {
                console.log('Hubo un error', error)
            }
            setLoading(false)
        },
        onUpdateBalance: (e) => {
            console.log(e.target.value)
            let _value = e.target.value
            setBalance(_value)
            //if(isNumeric(_value)){
            //    console.log('Numero valiudo', _value)
            //    _value = Number(_value)
            //    setBalance(_value.toString())
            //}else{
            //    //setBalance(0)
            //    //console.log('Numero erroneo', _value)
            //}
            
            //let _value = Number(e.target.value)
            //parseFloat(e.target.value)
            //console.log(_value)
            //if(isNaN(_value)) _value = 0
            setError(null)
        },
        onBlur: () => {
            console.log('Me sali', balance)
        },
        onIncrement: () => {
            setMode(1)
            //let _value = Number(balance)
            //_value += AMOUNT
            //setBalance(_value)
            //setError(null)
        },
        onDecrement: () => {
            setMode(-1)
            //let _value = Number(balance)
            //_value -= AMOUNT
            //if(_value < 0) _value = 0
            //setBalance(_value)
            //setError(null)
        },
        onReturn: async() => {
            setSending(true)
            try {
                console.log(cardholder)
                const cardID = cardholder?.idCard
                console.log('Card ID -> ', cardID)
                axios.defaults.headers.common['Authorization'] = authToken
                const response = await axios.get(`/balance/${cardID}/closed`)
                const _balance = response.data.data.balance
                console.log(_balance)
                setBalance(0)
                setOriginalBalance(_balance)
                setSucces(false)
                //setForm(_form)
            } catch (error) {
                console.log('Hubo un error', error)
            }
            setSending(false)
        },
        onSubmit: async() => {
            let type = mode === 1 ? 'increase' : 'decrease'
            if(balance < 0 ){
                setError('Only positive values are allowed')
                return
            }

            let final_amount = balance


            let data2send = {
                amount:final_amount
            }
            const cardID = cardholder?.idCard
            let url = `/balance/${cardID}/closed/${type}`
            console.log(url, data2send)

            setSending(true)
            try {
                axios.defaults.headers.common['Authorization'] = authToken
                const response = await axios.post(url, data2send)
                console.log(response.data)
                if(response?.data?.success === false){
                    const errorMessage = response?.data?.errors?.message
                    setError(errorMessage??'We cannot updated your balance, please try again')
                    setSending(false)
                    return
                }
            } catch (error) {
                const errorMessage = ''
                console.log(error)
                setError('We cannot updated your balance, please try again')
                setSending(false)
                return
            }

            setSending(false)
            setSucces(true)
        }
        
    }



    const system = {loading, sending, error}
    const view_data = {step, balance, originalBalance, success, mode}

    return {system, view_data, actions }
}

export default useBalanceModal
